import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('applicationFormFields');

    return {
        APPLICATION_NAME_FIELD_PLACEHOLDER: t('applicationNameFieldPlaceholder')
    };
};

export default useTranslation;
